import { ProductRequirementGroup } from '../data-collection.dto';
import { DealWithServices } from '../real-estate-asset-management.dto';

export function serviceInformationGroups(groups: ProductRequirementGroup[]): ProductRequirementGroup[] {
    return groups.filter((g) => g.placement === 'service_information');
}

/** Product ids of the REA's ACTIVE connected services — the gate for service-information editing. */
export function activeProductIds(reaServices: DealWithServices[]): Set<string> {
    return new Set(
        reaServices.flatMap((deal) =>
            deal.services.filter((s) => s.status === 'ACTIVE' && s.productId).map((s) => s.productId as string),
        ),
    );
}

/**
 * Which service-information groups can be edited for this REA: a group is
 * enabled when at least one ACTIVE connected service's product contributes a
 * field to it (`productIds` is the merge's per-product provenance). Values are
 * stored per service, so without a matching service there is nothing to write
 * to — the tab stays visible but disabled (GEN-591).
 */
export function enabledServiceInfoGroupCodes(
    groups: ProductRequirementGroup[],
    activeProductIds: Set<string>,
): Set<string> {
    return new Set(
        groups
            .filter((g) => g.requirementFields.some((f) => f.productIds?.some((id) => activeProductIds.has(id))))
            .map((g) => g.code),
    );
}
